import { NotFound } from "@bisom/web_package";

// Layouts
const AuthenticationLayout = () => import("@/layouts/authentication.vue");
const AuthenticatedLayout = () => import("@/layouts/authenticated.vue");
const AtsuLayout = () => import("@/layouts/atsuLayout.vue");

// authentication child
const AvailableVersionNUser = () => import("@/views/authenticationChild/IsAuthToStartView.vue");
const LoadingReferentials = () => import("@/views/authenticationChild/LoadingReferentials.vue");

// authenticated child
const HomeView = () => import("@/views/HomeView.vue");
const InformationView = () => import("@/views/InformationView.vue");
const ApRegulation = () => import("@/views/ApRegulation.vue");
const MapView = () => import("@/views/MapView.vue");
const VideoRegul = () => import("@/views/VideoRegul.vue");
const MissionsView = () => import("@/views/MissionsView.vue");
const ArmView = () => import("@/views/ArmView.vue");
const DashboardView = () => import("@/views/DashboardView.vue");
const Atsu = () => import("@/views/Atsu.vue");
const AtsuPlanning = () => import("@/views/atsu/AtsuPlanning.vue");
const AtsuMap = () => import("@/views/atsu/AtsuMap.vue");
const AtsuRegulation = () => import("@/views/atsu/AtsuRegulation.vue");
const HistoryView = () => import("@/views/HistoryView.vue");
const ExportView = () => import("@/views/ExportView.vue");
const ProgExportView = () => import("@/views/ProgExportView.vue");

// basic layout
const basicLayoutVue = () => import("@/layouts/basicLayout.vue");
const MissionLive = () => import("@/views/MissionLive.vue");
const MissionChat = () => import("@/views/MissionChat.vue");

// bilan layout
const BilanLayout = () => import("@/layouts/bilanLayout.vue");
const BilanInterView = () => import("@/views/BilanInterView.vue");

// public layout
const ExternalIdp = () => import("@/views/public/ExternalIdp.vue");
const WrongIpAddress = () => import("@/views/public/WrongIpAddress.vue");

// Outaded browser
const OutdatedBrowser = () => import("@/views/OutdatedBrowserView.vue");

const routes = [
  {
    path: "/",
    redirect: "/init/available",
  },
  {
    path: "/init",
    component: AuthenticationLayout,
    children: [
      {
        path: "available",
        name: "isAvailable",
        component: AvailableVersionNUser,
      },
      {
        path: "referantialsLoading",
        name: "referantialsLoading",
        component: LoadingReferentials,
      },
    ],
  },
  {
    path: "/auth",
    component: AuthenticatedLayout,
    children: [
      {
        path: "home",
        name: "home",
        component: HomeView,
      },
      {
        path: "info",
        name: "information",
        component: InformationView,
      },
      {
        path: "apRegulation",
        name: "ap_regulation",
        component: ApRegulation,
      },
      {
        path: "map",
        name: "mission_map",
        component: MapView,
      },
      {
        path: "videoregul",
        name: "video_regul",
        component: VideoRegul,
      },
      {
        path: "missions",
        name: "missions",
        component: MissionsView,
      },
      {
        path: "arm",
        name: "arm",
        component: ArmView,
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: DashboardView,
      },
      {
        path: "history",
        name: "history",
        component: HistoryView,
      },
      {
        path: "archive",
        name: "archive",
        component: HistoryView,
      },
      {
        path: "export",
        name: "export",
        component: ExportView,
      },
      {
        path: "prog_export",
        name: "prog_export",
        component: ProgExportView,
      },
      {
        path: "404",
        name: "404",
        component: NotFound,
      },
    ],
  },
  {
    path: "/auth",
    component: AtsuLayout,
    children: [
      {
        path: "ambulanceDispatch",
        name: "atsu",
        component: Atsu,
      },

      {
        path: "ambulanceDispatch/planning",
        name: "atsu_planning",
        component: AtsuPlanning,
      },
      {
        path: "ambulanceDispatch/map",
        name: "atsu_map",
        component: AtsuMap,
      },
      {
        path: "ambulanceDispatch/regulation",
        name: "atsu_regulation",
        component: AtsuRegulation,
      },
    ],
  },
  {
    path: "/mission",
    component: BilanLayout,
    children: [
      {
        path: ":mission_id/bilan_inter",
        name: "bilan_inter",
        component: BilanInterView,
      },
    ],
  },
  {
    path: "/public",
    component: basicLayoutVue,
    children: [
      {
        path: "/external_idp",
        name: "externalIdp",
        component: ExternalIdp,
      },
      {
        path: "/wrongIpAddress",
        name: "wrong_ip_addres",
        component: WrongIpAddress,
      },
    ],
  },
  {
    path: "/room/:mission_id",
    component: basicLayoutVue,
    children: [
      {
        path: "live",
        name: "live",
        component: MissionLive,
      },
      {
        path: "chat",
        name: "chat",
        component: MissionChat,
      },
    ],
  },
  {
    path: "/404",
    redirect: "/auth/404",
  },
  {
    path: "/outdated",
    name: "outdated",
    component: OutdatedBrowser,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/auth/404",
  },
];

export default routes;
